import { defineStore } from 'pinia'

type State = {
  title: string,
  modalConfirmPassword: ModalConfirmPassword | null,
}

type ModalConfirmPassword = {
  open: (callback: () => void) => void,
}

const APP_TITLE = import.meta.env.VITE_APP_TITLE ?? ''

export const usePageStore = defineStore('Page', {
  state: (): State => ({
    title: '',
    modalConfirmPassword: null,
  }),
  actions: {
    setPageTitle (title: string) {
      this.title = title
      document.title = `${title} | ${APP_TITLE}`
    },
    setModalConfirmPassword (modal: ModalConfirmPassword | null) {
      this.modalConfirmPassword = modal
    },
  },
})
